<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <div class="Actions__Content" style="padding: 10px">
      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex xs11 pa-2>
                <v-autocomplete
                  v-model="vinery_block_select"
                  :items="vinery_block_items"
                  item-text="name"
                  item-value="id"
                  label="Parcele"
                  persistent-hint
                  return-object
                  ref="element1"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  v-on:change="getAllGrapeVarietyChangeBlock"
                  outlined
                  dense
                ></v-autocomplete>
              </v-flex>
              <v-flex xs1 style="text-align: right">
                <v-btn
                  @click="submitKartice"
                  class="AppButtonFilled"
                  style="margin-top: 15px"
                  >Pretraži</v-btn
                >
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex xs11 pa-2>
                <v-autocomplete
                  v-model="vinery_table_select"
                  :items="vinery_table_items"
                  item-text="name"
                  item-value="id"
                  label="Table"
                  persistent-hint
                  return-object
                  ref="element11"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                  v-on:change="getAllGrapeVarietyChangeTable"
                ></v-autocomplete>
                <!--  -->
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs7
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="grape_variety_select"
                  :items="grape_variety_items"
                  item-text="name"
                  item-value="id"
                  label="Sorta"
                  persistent-hint
                  return-object
                  ref="element2"
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                ></v-autocomplete>
              </v-flex>
              <v-flex xs1 pa-2>
                <div class="div_prozorce" v-if="broj_sorti !== 0">
                  <p class="gornji_text" v-html="broj_sorti"></p>
                  <p
                    class="donji_text"
                    v-html="formatTekstaSorta2(broj_sorti)"
                  ></p>
                </div>
                <div class="div_prozorce" v-else>
                  <p class="gornji_text">-</p>
                  <p class="donji_text">sorti</p>
                </div>
              </v-flex>
              <v-flex xs1 pa-2>
                <div class="div_prozorce" v-if="broj_redova !== 0">
                  <p class="gornji_text" v-html="broj_redova"></p>
                  <p
                    class="donji_text"
                    v-html="formatTekstaRed2(broj_redova)"
                  ></p>
                </div>
                <div class="div_prozorce" v-else>
                  <p class="gornji_text">-</p>
                  <p class="donji_text">redova</p>
                </div>
              </v-flex>
              <v-flex xs1 pa-2>
                <div class="div_prozorce" v-if="broj_kalemova !== 0">
                  <p class="gornji_text" v-html="broj_kalemova"></p>
                  <p
                    class="donji_text"
                    v-html="formatTekstaKalem2(broj_kalemova)"
                  ></p>
                </div>
                <div class="div_prozorce" v-else>
                  <p class="gornji_text">-</p>
                  <p class="donji_text">čokota</p>
                </div>
              </v-flex>
              <v-flex xs1 pa-2>
                <template v-if="povrsina > 1000">
                  <div class="div_prozorce" v-if="broj_sorti !== 0">
                    <p
                      class="gornji_text"
                      v-html="Math.round(povrsina / 100) / 100"
                    ></p>
                    <p class="donji_text">ha</p>
                  </div>
                </template>
                <template v-else-if="povrsina > 0">
                  <div class="div_prozorce" v-if="broj_sorti !== 0">
                    <p
                      class="gornji_text"
                      v-html="Math.round(povrsina) / 100"
                    ></p>
                    <p class="donji_text">ar</p>
                  </div>
                </template>
                <template v-else>
                  <div class="div_prozorce">
                    <p class="gornji_text">-</p>
                    <p class="donji_text">ar</p>
                  </div>
                </template>
              </v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <!-- <download-excel
                :data="json_data"
                :fields="json_fields"
                :meta="json_meta"
                :name="naziv_fajla"
                :param="json_fields"
              >
                <img
                  src="../assets/menuIcons/ico-print.png"
                  title="Štampa dokumenta"
                />
              </download-excel> -->

                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex xs12 style="overflow: auto">
              <v-data-table
                item-key="rowId"
                :headers="headers_states"
                :items="items_states"
                show-select
                hide-actions
                dense
                :pagination.sync="pagination"
                :search="search"
                expand
                fixed-header
                select-all
                ref="dTable"
              >
                <template slot="headers" slot-scope="props_modal">
                  <tr style="text-align: center; padding: 5px">
                    <!-- <th>
                  
                </th> -->
                    <th
                      :style="[
                        'text-align: center' + header.width !== null
                          ? '; width: ' + header.width + 'px'
                          : '',
                      ]"
                      v-for="header in props_modal.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon
                        small
                        v-if="
                          header.sortable !== false &&
                          header.sortable !== undefined
                        "
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props_modal">
                  <tr>
                    <td style="display: none">
                      {{ props_modal.item.rowId }}
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0px;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ props_modal.item.rowNumber }}
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0px;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                      v-if="props_modal.item.block !== null"
                    >
                      {{ props_modal.item.block }}
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0px;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                      v-else
                    >
                      {{ "-" }}
                    </td>
                    <!-- <td
                      style="
                        text-align: center !important;
                        padding: 0%;
                        width: 20% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ formatTabli(props_modal.item.tables) }}
                    </td> -->
                    <td
                      v-if="props_modal.item.tables.length > 2"
                      style="
                        text-align: center !important;
                        padding: 0%;
                        width: 20% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ formatImena(props_modal.item.tables) }}
                      <template v-if="props_modal.item.tables !== null">
                        <v-menu
                          open-on-hover
                          top
                          offset-x
                          nudge-right="20"
                          close-delay="100"
                          v-if="props_modal.item.tables.length > 0"
                        >
                          <template v-slot:activator="{}">
                            <v-icon
                              slot="activator"
                              small
                              class="ml-2"
                              color="teal"
                            >
                              info
                            </v-icon>
                            <span>
                              <v-container style="background-color: white">
                                <div class="DataTable">
                                  <v-layout>
                                    <v-flex
                                      xs12
                                      pa-2
                                      style="font-size: 20px !important"
                                    >
                                      Spisak tabli
                                    </v-flex>
                                  </v-layout>

                                  <v-layout column>
                                    <v-flex style="overflow: auto">
                                      <v-data-table
                                        :headers="
                                          headers_modal_izabrani_tankovi
                                        "
                                        :items="props_modal.item.tables"
                                        hide-actions
                                        class="elevation-1"
                                        show-select
                                        dense
                                        select-all
                                        :pagination.sync="pagination"
                                      >
                                        <template
                                          slot="headers"
                                          slot-scope="props_modal"
                                        >
                                          <tr>
                                            <th
                                              style="
                                                text-align: center;
                                                padding: 5px;
                                              "
                                              v-for="header in props_modal.headers"
                                              :key="header.text"
                                            >
                                              {{ header.text }}
                                            </th>
                                          </tr>
                                        </template>
                                        <template
                                          slot="items"
                                          slot-scope="props_modal"
                                        >
                                          <tr>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{ props_modal.item }}
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-container>
                            </span>
                          </template>
                        </v-menu>
                      </template>
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0%;
                        width: 20% !important;
                      "
                      v-else-if="props_modal.item.tables.length > 0"
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ formatTabli(props_modal.item.tables) }}
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0%;
                        width: 20% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                      v-else
                    >
                      -
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0%;
                        width: 20% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ formatRedova(props_modal.item.grapeVarieties) }}
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0%;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ props_modal.item.distanceBetweenRows }} m
                    </td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0px;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    ></td>
                    <td
                      style="
                        text-align: center !important;
                        padding: 0px;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    ></td>
                    <td
                      style="
                        text-align: right !important;
                        padding-right: 24px;
                        width: 10% !important;
                      "
                      @click="props_modal.expanded = !props_modal.expanded"
                    >
                      {{ formatInt(props_modal.item.brojCokota) }}
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props_modal">
                  <v-data-table
                    item-key="id_pom"
                    :headers="headers_modal_izabrani_redovi_pom"
                    :items="props_modal.item.positions"
                    hide-actions
                    class="elevation-1"
                    show-select
                    dense
                    :pagination.sync="pagination"
                    :search="search"
                  >
                    <template slot="headers" slot-scope="props_modal_1">
                      <tr style="height: 1px !important">
                        <th
                          style="text-align: center; padding: 5px"
                          v-for="header in props_modal_1.headers"
                          :key="header.text"
                          :class="[
                            'column sortable',
                            pagination.descending ? 'desc' : 'asc',
                            header.value === pagination.sortBy ? 'active' : '',
                          ]"
                          @click="changeSortKartica(header.value)"
                        >
                          <v-icon small v-if="header.sortable !== false"
                            >arrow_upward</v-icon
                          >
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="props_modal_1">
                      <tr class="custom-highlight-row">
                        <td style="width: 20%; padding: 0px"></td>
                        <td
                          style="text-align: center; width: 20%; padding: 0px"
                        >
                          <template v-if="props_modal_1.item.table !== null">
                            {{ props_modal_1.item.table }}
                          </template>
                          <template v-else>
                            {{ "-" }}
                          </template>
                        </td>
                        <td
                          style="text-align: center; width: 20%; padding: 0px"
                        >
                          <template
                            v-if="props_modal_1.item.grapeVariety !== null"
                          >
                            {{ props_modal_1.item.grapeVariety }}
                          </template>
                          <template v-else>
                            {{ "-" }}
                          </template>
                        </td>
                        <td
                          style="text-align: center; width: 10%; padding: 0px"
                        >
                          <template
                            v-if="
                              props_modal_1.item.distanceBetweenPlants !== null
                            "
                          >
                            {{
                              formatInt(
                                props_modal_1.item.distanceBetweenPlants
                              )
                            }}
                            m
                          </template>
                          <template v-else>
                            {{ "-" }}
                          </template>
                        </td>
                        <td
                          style="text-align: center; width: 10%; padding: 0px"
                        >
                          <template
                            v-if="props_modal_1.item.plantNumberFrom !== null"
                          >
                            {{ formatInt(props_modal_1.item.plantNumberFrom) }}
                          </template>
                          <template v-else>
                            {{ "-" }}
                          </template>
                        </td>

                        <td
                          style="text-align: center; width: 10%; padding: 0px"
                        >
                          <template
                            v-if="props_modal_1.item.plantNumberTo !== null"
                          >
                            {{ formatInt(props_modal_1.item.plantNumberTo) }}
                          </template>
                          <template v-else>
                            {{ "-" }}
                          </template>
                        </td>

                        <td style="text-align: right; width: 10%">
                          <template v-if="props_modal_1.item.cokota !== null">
                            {{ formatInt(props_modal_1.item.cokota) }}
                          </template>
                          <template v-else>
                            {{ "-" }}
                          </template>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="primary"
                        icon="info"
                        >Nema podataka.</v-alert
                      >
                    </template>
                  </v-data-table>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- <v-layout
            row
            wrap
            style="max-height: 60px !important; padding-top: 15px !important"
          >
            <v-flex xs9> </v-flex>

            <v-flex
              xs3
              pa-2
              style="
                padding-right: 2% !important;
                text-align: right;
                border-top-style: solid !important;
                border-top-width: 1px !important;
                border-top-color: rgba(0, 0, 0, 0.2);
              "
            >
              Ukupno čokota:
              {{ this.formatInt(this.total) }}
            </v-flex>
          </v-layout> -->
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";
import {
  readJSON,
  prevediOperacije3,
  prevediOperacije3SaSrpskog,
  getDateTime,
  getDateTimeNaslov,
  daLiJeVinarija,
} from "../helpers/Functions";

import html2pdf from "html2pdf.js";

export default {
  props: ["vineyard_id", "naziv_vinograda"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,

    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      headers_states: [
        { text: "Red" },
        { text: "Parcela" },
        { text: "Tabla" },
        { text: "Sorta", value: "", align: "center" },
        {
          text: "Razmak",
          value: "",
          align: "center",
          sortable: false,
        },
        { text: "Od čokota", value: "", align: "center" },
        { text: "Do čokota", value: "", align: "center" },
        { text: "Čokota", value: "", align: "right" },
      ],
      items_states: [],
      listSize: [5, 10, 25, 50, 100, { text: "Svi", value: 1000000 }],
      pagination: {
        sortBy: "date",
        rowsPerPage: 1000000,
        descending: true,
        page: 1,
      },
      search: "",
      izabranaStranica: 0,
      grape_variety_select: null,
      grape_variety_items: [],
      vinery_block_items: [],
      vinery_block_select: undefined,
      vinery_table_items: [],
      vinery_table_select: undefined,

      loading: true,

      vinogradiFilter: "",
      tableFilter: "",
      fiterOperacija: "",
      naslov: "",
      podnaslov: "",

      json_fields_type: [],

      json_fields: {
        Red: "String",
        Parcela: "String",
        Tabla: "String",
        Sorta: "String",
        Razmak: "String",
        OdC: "String",
        DoC: "String",
        Čokota: "String",
      },

      headers_modal_izabrani_redovi_pom: [],
      total: 0,
      broj_sorti: 0,
      broj_redova: 0,
      broj_kalemova: 0,
      povrsina: 0,
      headers_modal_izabrani_tankovi: [
        { text: "Naziv", value: "", align: "center" },
      ],
      vinarija: true,
      odCokota: "Od čokota",
      doCokota: "Do čokota"
    };
  },
  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search,
      };
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (
          this.vineyard_id !== undefined &&
          this.vineyard_id !== 0 &&
          this.vineyard_id !== null
        )
          if (
            (newVal.page !== oldVal.page ||
              newVal.rowsPerPage !== oldVal.rowsPerPage ||
              newVal.sortBy !== oldVal.sortBy ||
              newVal.descending !== oldVal.descending) &&
            newVal.sortBy !== ""
          ) {
            this.izabranaStranica = this.pagination.page - 1;

            this.getAllKartice();
          }
      },
      deep: true,
    },
    vineyard_id: function (val) {
      this.clear();
      this.items_states = [];

      if (val !== null && val !== undefined && val !== 0) {
        this.getParcele();
        // this.getAllGrapeVariety();

        this.getAllKartice();
      }
    },
    naziv_vinograda: function (val) {},
  },

  methods: {
    formatImena(item) {
      let returnText = "";

      if (item !== undefined)
        if (item.length === 0) returnText = "";
        else if (
          item.length % 10 >= 2 &&
          item.length % 10 <= 4 &&
          item.length !== 12 &&
          item.length !== 13 &&
          item.length !== 14
        )
          returnText = item.length + " table";
        else {
          if (item.length % 10 === 1 && item.length !== 11)
            returnText = item.length + " tabla";
          else returnText = item.length + " tabli";
        }
      else returnText = item;

      return returnText;
    },
    formatInt(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaKalem2(broj) {
      let tekst = "";

      if (this.vinarija) {
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      } else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";
      }

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    formatTabli(niz) {
      let tekst = "";

      if (niz !== undefined)
        if (niz.length > 0) {
          niz.forEach(function (entry) {
            tekst = tekst + entry + ", ";
          });

          tekst = tekst.substring(0, tekst.length - 2);
        }

      return tekst;
    },
    formatRedova(niz) {
      let tekst = "";

      if (niz.length > 0) {
        niz.forEach(function (entry) {
          tekst = tekst + entry + ", ";
        });

        tekst = tekst.substring(0, tekst.length - 2);
      }

      return tekst;
    },
    submitKartice() {
      if (this.$refs.form.validate()) this.getAllKartice();
    },
    stampaj() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint2.style.margin = "0px";
        elementToPrint.append(elementToPrint2);

        var elementToPrint3 = document.createElement("p");
        elementToPrint3.innerHTML = _this.podnaslov;

        elementToPrint3.style.position = "relative";
        elementToPrint3.style.textAlign = "center";
        elementToPrint3.style.fontSize = "14px";

        elementToPrint.append(elementToPrint3);

        var div = document.createElement("div");
        div.style.borderColor = "white";
        div.style.borderStyle = "solid";
        div.style.height = "100%";
        div.style.borderRadius = "15px";
        div.style.width = "33%";
        div.style.paddingBottom = "5px";
        div.style.marginLeft = "66%";

        var p1 = document.createElement("p");

        p1.style.fontSize = "18px";
        p1.style.margin = "0px";
        p1.style.paddingTop = "0px";
        p1.style.textAlign = "center";
        p1.style.lineHeight = "0";
        p1.style.width = "25%";

        p1.innerHTML = this.broj_sorti !== 0 ? this.broj_sorti : "-";
        div.appendChild(p1);

        var p11 = document.createElement("p");

        p11.style.fontSize = "18px";
        p11.style.margin = "0px";
        p11.style.paddingTop = "0px";
        p11.style.textAlign = "center";
        p11.style.lineHeight = "0";
        p11.style.width = "25%";
        p11.style.marginLeft = "25%";

        p11.innerHTML = this.broj_redova !== 0 ? this.broj_redova : "-";
        div.appendChild(p11);

        var p111 = document.createElement("p");

        p111.style.fontSize = "18px";
        p111.style.margin = "0px";
        p111.style.paddingTop = "0px";
        p111.style.textAlign = "center";
        p111.style.lineHeight = "0";
        p111.style.width = "25%";
        p111.style.marginLeft = "50%";

        p111.innerHTML = this.broj_kalemova !== 0 ? this.broj_kalemova : "-";
        div.appendChild(p111);

        var p1111 = document.createElement("p");

        p1111.style.fontSize = "18px";
        p1111.style.margin = "0px";
        p1111.style.paddingTop = "0px";
        p1111.style.paddingBottom = "5px";
        p1111.style.textAlign = "center";
        p1111.style.lineHeight = "0";
        p1111.style.width = "25%";
        p1111.style.marginLeft = "75%";

        p1111.innerHTML =
          this.povrsina > 1000
            ? Math.round(this.povrsina / 100) / 100
            : this.povrsina > 0
            ? Math.round(this.povrsina) / 100
            : "-";
        div.appendChild(p1111);

        var p2 = document.createElement("p");
        p2.style.fontSize = "12px";
        p2.style.margin = "0px";
        p2.style.paddingTop = "10px";
        p2.style.lineHeight = "0";
        p2.style.textAlign = "center";
        p2.style.width = "25%";

        p2.innerHTML = this.formatTekstaSorta2(this.broj_sorti);
        div.appendChild(p2);

        var p21 = document.createElement("p");
        p21.style.fontSize = "12px";
        p21.style.margin = "0px";
        p21.style.paddingTop = "0px";
        p21.style.lineHeight = "0";
        p21.style.textAlign = "center";
        p21.style.width = "25%";
        p21.style.marginLeft = "25%";

        p21.innerHTML = this.formatTekstaRed2(this.broj_redova);
        div.appendChild(p21);

        var p211 = document.createElement("p");
        p211.style.fontSize = "12px";
        p211.style.margin = "0px";
        p211.style.paddingTop = "0px";
        p211.style.lineHeight = "0";
        p211.style.textAlign = "center";
        p211.style.width = "25%";
        p211.style.marginLeft = "50%";

        p211.innerHTML = this.formatTekstaKalem2(this.broj_kalemova);
        div.appendChild(p211);

        var p2111 = document.createElement("p");
        p2111.style.fontSize = "12px";
        p2111.style.margin = "0px";
        p2111.style.paddingTop = "0px";
        p2111.style.lineHeight = "0";
        p2111.style.textAlign = "center";
        p2111.style.width = "25%";
        p2111.style.marginLeft = "75%";

        p2111.innerHTML = this.povrsina > 1000 ? "ha" : "ar";
        div.appendChild(p2111);

        elementToPrint.appendChild(div);

        if (
          _this.tableFilter !== "" ||
          _this.vinogradiFilter !== "" ||
          _this.fiterOperacija !== ""
        ) {
          let pomocni_tekst = "";

          if (_this.vinogradiFilter !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Parcela: " +
              _this.vinogradiFilter.substring(
                0,
                _this.vinogradiFilter.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.tableFilter !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Tabla: " +
              _this.tableFilter.substring(0, _this.tableFilter.length - 2);
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.fiterOperacija !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Sorta: " +
              _this.fiterOperacija.substring(
                0,
                _this.fiterOperacija.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";

        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            var valNiz = val.toString().split("|");

            if (valNiz[0] === null || valNiz[0] === 0)
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(valNiz[0]);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" &&
              valNiz.length > 1
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px; font-weight: bold;"
              );
            } else if (_this.json_fields_type[pomJ] === "Number") {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else if (valNiz.length > 1)
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; font-weight: bold;"
              );
            else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );
            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
          }

          tblBody.appendChild(row);
        });

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 815px";
        tbl.style.width = "245px";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    getAllGrapeVarietyChangeTable(e) {
      if (this.vineyard_id !== undefined && e !== undefined && this.loading) {
        let _this = this;
        let url = "/vineyard/" + this.vineyard_id + "/grape_varietis?";

        if (
          this.vinery_block_select !== undefined &&
          this.vinery_block_select !== null &&
          this.vinery_block_select.length > 0
        ) {
          this.vinery_block_select.forEach(function (entry) {
            url = url + "blockId=" + entry.id + "&";
          });
        }

        if (
          this.vinery_table_select !== undefined &&
          this.vinery_table_select !== null &&
          this.vinery_table_select.length > 0
        ) {
          this.vinery_table_select.forEach(function (entry) {
            url = url + "tableId=" + entry.id + "&";
          });
        }
        url = url.substring(0, url.length - 1);

        this.$http
          .get(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            _this.grape_variety_items = response.data;
            _this.grape_variety_select = [];
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(this.globalServiceLocation + this.globalPort + url, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      })
                      .then((response) => {
                        _this.grape_variety_items = response.data;

                        _this.grape_variety_select = [];
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    dajSveTable() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/vineyard_table/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          this.vinery_table_items = response.data;
          this.vinery_table_select = this.glob_tabla;
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_table/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);
                      this.vinery_table_items = response.data;
                      this.vinery_table_select = this.glob_tabla;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    dajSveTableUBloku(id_block) {
      if (id_block === "") this.items = [];
      else {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard_table/vineyard_block?" +
              id_block,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);
            this.vinery_table_items = response.data;
            this.vinery_table_select = this.glob_tabla;
          })
          .catch((e) => {
            // // console.log(e.response);
            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard_table/vineyard_block?" +
                          id_block,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response.data);
                        this.vinery_table_items = response.data;
                        this.vinery_table_select = this.glob_tabla;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getAllGrapeVarietyChangeBlock(e) {
      if (this.vineyard_id !== undefined && e !== undefined && this.loading) {
        let _this = this;
        let url = "/vineyard/" + this.vineyard_id + "/grape_varietis?";
        let pomTableId = "";

        if (
          this.vinery_block_select !== undefined &&
          this.vinery_block_select !== null &&
          this.vinery_block_select.length > 0
        ) {
          this.vinery_block_select.forEach(function (entry) {
            url = url + "blockId=" + entry.id + "&";
            pomTableId = pomTableId + "vineyardBlockId=" + entry.id + "&";
          });
        }

        this.dajSveTableUBloku(pomTableId);

        if (
          this.vinery_table_select !== undefined &&
          this.vinery_table_select !== null &&
          this.vinery_table_select.length > 0
        ) {
          this.vinery_table_select.forEach(function (entry) {
            url = url + "tableId=" + entry.id + "&";
          });
        }
        url = url.substring(0, url.length - 1);

        this.$http
          .get(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            _this.grape_variety_items = response.data;
            _this.grape_variety_select = [];
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(this.globalServiceLocation + this.globalPort + url, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      })
                      .then((response) => {
                        _this.grape_variety_items = response.data;

                        _this.grape_variety_select = [];
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getAllGrapeVariety() {
      if (this.vineyard_id !== undefined && this.vineyard_id !== 0) {
        let url = "";

        url =
          this.globalServiceLocation +
          this.globalPort +
          "/vineyard/" +
          this.vineyard_id +
          "/grape_varietis";

        this.$http
          .get(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.grape_variety_items = response.data;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(url, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      })
                      .then((response) => {
                        this.grape_variety_items = response.data;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getAllKartice() {
      this.isLoading = true;

      if (!this.vinarija) {
        
        
        this.odCokota = "Od biljke";
        this.doCokota = "Do biljke";
        this.cokota = "Biljke";

        this.naslov = "Pregled zasada - " + this.naziv_vinograda;
      } else this.naslov = "Pregled vinograda - " + this.naziv_vinograda;

      this.podnaslov = getDateTimeNaslov();

      this.json_fields = JSON.parse('{"Red": "String", "Parcela": "String", "Tabla": "String","Sorta": "String","Razmak": "String","' + this.odCokota + '": "String","' + this.doCokota + '": "String","' + this.cokota + '": "String"}');

      this.headers_states = [
          { text: "Red" },
          { text: "Parcela" },
          { text: "Tabla" },
          { text: "Sorta", value: "", align: "center" },
          {
            text: "Razmak",
            value: "",
            align: "center",
            sortable: false,
          },
          { text: this.odCokota, value: "", align: "center" },
          { text: this.doCokota, value: "", align: "center" },
          { text: this.cokota, value: "", align: "right" },
        ];
        
      this.json_fields_type = [
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "Number",
      ];

      let _this = this;
      var pom_vinery_block_to_select = "";

      this.vinogradiFilter = "";

      if (
        this.vinery_block_select !== undefined &&
        this.vinery_block_select !== null
      ) {
        this.vinery_block_select.forEach(function (entry) {
          pom_vinery_block_to_select =
            pom_vinery_block_to_select + "blockId=" + entry.id + "&";

          _this.vinogradiFilter = _this.vinogradiFilter + entry.name + ", ";
        });
      }

      var pom_vinery_table_to_select = "";
      this.tableFilter = "";

      if (
        this.vinery_table_select !== undefined &&
        this.vinery_table_select !== null
      ) {
        this.vinery_table_select.forEach(function (entry) {
          pom_vinery_table_to_select =
            pom_vinery_table_to_select + "tableId=" + entry.id + "&";

          _this.tableFilter = _this.tableFilter + entry.name + ", ";
        });
      }

      var pom_grape_variety_select = "";
      this.fiterOperacija = "";

      if (
        this.grape_variety_select !== undefined &&
        this.grape_variety_select !== null
      ) {
        this.grape_variety_select.forEach(function (entry) {
          pom_grape_variety_select =
            pom_grape_variety_select + "grapeVarietyId=" + entry.id + "&";

          _this.fiterOperacija = _this.fiterOperacija + entry.name + ", ";
        });
      }

      let sortiranje = "";
      if (this.pagination.sortBy !== "") {
        let orderovanje = "";
        if (this.pagination.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.pagination.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/vineyard_grape_variety_row/used_position_in_vineyard/" +
        this.vineyard_id +
        "?" +
        pom_grape_variety_select +
        pom_vinery_block_to_select +
        pom_vinery_table_to_select;

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      setTimeout(() => {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              urlLoc +
              "&page=" +
              this.izabranaStranica +
              "&offset=" +
              this.pagination.rowsPerPage,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.total = 0;
            this.items_states = response.data;

            if (this.items_states.length > 0) {
              this.items_states.forEach(function (e) {
                let brojCokota = 0;

                e.positions.forEach(function (e1) {
                  e1["id_pom"] =
                    e.rowId + "_" + e1.plantNumberFrom + "_" + e1.plantNumberTo;
                  e1["cokota"] = e1.plantNumberTo - e1.plantNumberFrom + 1;

                  brojCokota =
                    brojCokota + e1.plantNumberTo - e1.plantNumberFrom + 1;
                });

                e.brojCokota = brojCokota;
              });
            }

            this.json_data = [];
            let rbr = 1;

            let objekat;

            this.broj_sorti = 0;
            this.broj_kalemova = 0;
            this.povrsina = 0;
            let counts = [];

            this.items_states.forEach(function (entry) {
              let razmakIzmedjuRedova = entry.distanceBetweenRows;

              objekat = {
                  Red: entry.rowNumber + "|bold",
                  Parcela:
                    entry.block !== null ? entry.block + "|bold" : "-|bold",
                  Tabla: _this.formatTabli(entry.tables) + "|bold",
                  Sorta: _this.formatRedova(entry.grapeVarieties) + "|bold",
                  Razmak: entry.distanceBetweenRows + "|bold",
                  OdC: "",
                  DoC: "",
                  Čokota: entry.brojCokota + "|bold",
                };
                
              entry.grapeVarieties.forEach(function (e) {
                if (!counts.includes(e)) {
                  counts.push(e);
                }
              });

              _this.json_data.push(objekat);

              entry.positions.forEach(function (entry1) {
                _this.total =
                  _this.total +
                  (entry1.plantNumberTo - entry1.plantNumberFrom + 1);

                _this.povrsina =
                  _this.povrsina +
                  razmakIzmedjuRedova *
                    (entry1.plantNumberTo - entry1.plantNumberFrom + 1) *
                    entry1.distanceBetweenPlants;

                objekat = {
                  Red: "",
                  Parcela: "",
                  Tabla: "",
                  Sorta: entry1.grapeVariety,
                  Razmak: entry1.distanceBetweenPlants,
                  OdC: _this.formatInt(entry1.plantNumberFrom),
                  DoC: _this.formatInt(entry1.plantNumberTo),
                  Čokota: _this.formatInt(entry1.cokota),
                };

                _this.json_data.push(objekat);
              });

              rbr = rbr + 1;
            });

            this.broj_kalemova = this.total;
            this.broj_sorti = counts.length;
            this.broj_redova = this.items_states.length;

            objekat = {
              Red: "",
              Parcela: "",
              Tabla: "",
              Sorta: "",
              Razmak: "",
              OdC: "",
              DoC: "Ukupno čokota:",
              Čokota: this.formatInt(this.total),
            };

            this.json_data.push(objekat);

            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;

              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlLoc +
                          strDate +
                          strDateDo +
                          "&page=" +
                          this.izabranaStranica +
                          "&offset=" +
                          this.pagination.rowsPerPage,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.total = 0;
                        this.items_states = response.data;

                        if (this.items_states.length > 0) {
                          this.items_states.forEach(function (e) {
                            let brojCokota = 0;

                            e.positions.forEach(function (e1) {
                              e1["id_pom"] =
                                e.rowId +
                                "_" +
                                e1.plantNumberFrom +
                                "_" +
                                e1.plantNumberTo;
                              e1["cokota"] =
                                e1.plantNumberTo - e1.plantNumberFrom + 1;

                              brojCokota =
                                brojCokota +
                                e1.plantNumberTo -
                                e1.plantNumberFrom +
                                1;
                            });

                            e.brojCokota = brojCokota;
                          });
                        }

                        this.json_data = [];
                        let rbr = 1;

                        let objekat;

                        this.items_states.forEach(function (entry) {
                          objekat = {
                            Red: entry.rowNumber + "|bold",
                            Parcela:
                              entry.block !== null ? entry.block + "|bold" : "-|bold",
                            Tabla: _this.formatTabli(entry.tables) + "|bold",
                            Sorta: _this.formatRedova(entry.grapeVarieties) + "|bold",
                            Razmak: entry.distanceBetweenRows + "|bold",
                            OdC: "",
                            DoC: "",
                            Čokota: entry.brojCokota + "|bold",
                          };

                          _this.json_data.push(objekat);

                          entry.positions.forEach(function (entry1) {
                            _this.total =
                              _this.total +
                              (entry1.plantNumberTo -
                                entry1.plantNumberFrom +
                                1);

                            objekat = {
                              Red: "",
                              Parcela: "",
                              Tabla: "",
                              Sorta: entry1.grapeVariety,
                              Razmak: entry.distanceBetweenPlants,
                              OdC: _this.formatInt(
                                entry1.plantNumberFrom
                              ),
                              DoC: _this.formatInt(
                                entry1.plantNumberTo
                              ),
                              Čokota: _this.formatInt(entry1.cokota),
                            };

                            _this.json_data.push(objekat);
                          });

                          rbr = rbr + 1;
                        });

                        objekat = {
                          Red: "",
                          Parcela: "",
                          Tabla: "",
                          Sorta: "",
                          Razmak: "",
                          OdC: "",
                          DoC: "Ukupno čokota:",
                          Čokota: this.formatInt(this.total),
                        };

                        this.json_data.push(objekat);

                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    getParcele() {
      if (this.vineyard_id !== undefined && this.vineyard_id !== 0) {
        let _this = this;

        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard/" +
              this.vineyard_id +
              "/blocks",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);
            _this.vinery_block_items = response.data;
          })
          .catch((e) => {
            // // console.log(e.response);
            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard/" +
                          this.vineyard_id +
                          "/blocks",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        _this.vinery_block_items = response.data;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getTable() {
      if (this.vineyard_id !== undefined && this.vineyard_id !== 0) {
        let _this = this;

        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard/" +
              this.vineyard_id +
              "/blocks",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);
            _this.vinery_table_items = response.data;
          })
          .catch((e) => {
            // // console.log(e.response);
            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard/" +
                          this.vineyard_id +
                          "/blocks",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        _this.vinery_table_items = response.data;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    clear() {
      this.$refs.form.reset();

      this.vinogradiFilter = "";
      this.tableFilter = "";
      this.fiterOperacija = "";
    },
    changeSortKartica(column) {
      if (this.items_states.length > 0)
        if (typeof column !== "undefined")
          if (column !== "funkcije")
            if (this.pagination.sortBy === column) {
              this.pagination.descending = !this.pagination.descending;
            } else {
              this.pagination.sortBy = column;
              this.pagination.descending = false;
            }
    },
  },
  mounted() {
    this.getParcele();
    this.getAllGrapeVariety();
    //this.dajSveTable();

    if (this.vineyard_id !== undefined && this.vineyard_id !== 0)
      this.getAllKartice();
  },

  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));
  },
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 10%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}

.custom-highlight-row {
  background-color: #f3f7f4;
}
button.AppButtonFilled.v-btn.teal.lighten-2 {
  margin-left: 3px !important;
}

.div_prozorce {
  border-color: white !important;
  border-style: solid !important;
  height: 100% !important;
  border-radius: 15px !important;
}

.gornji_text {
  font-size: 18px !important;
  margin: 0px !important;
  padding-top: 10px !important;
  text-align: center;
}

.donji_text {
  font-size: 12px !important;
  text-align: center;
  margin: 0px !important;
  line-height: 0.1 !important;
}
</style>